export type TunnelTokenInput = {
  gatewayAddr: string;
  clientCertPem: string;
  clientKeyPem: string;
  gatewayCaPem: string;
};

export function encodeTunnelToken(input: TunnelTokenInput): string {
  return btoa(
    JSON.stringify({
      gateway_addr: input.gatewayAddr,
      client_cert_pem: input.clientCertPem,
      client_key_pem: input.clientKeyPem,
      gateway_ca_pem: input.gatewayCaPem,
    })
  );
}
